import Vue from "vue";
import Vuex from "vuex";

import authStore from "./authStore";
import appStore from "./appStore";

Vue.use(Vuex);

export default function() {
  const Store = new Vuex.Store({
    modules: {
      authStore,
      appStore,
    },
    strict: process.env.DEV,
  });

  return Store;
}
